import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_SNACK_BAR_DEFAULT_OPTIONS as MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/legacy-snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from '@cutting/app.component';
import { fuseConfig } from '@cutting/fuse-config';
import { LayoutModule } from '@cutting/layout/layout.module';
import { TokenInterceptor } from '@cutting/main/client/authentication/token-manager/token-manager.interceptor';
import { TokenManagerService } from '@cutting/main/client/authentication/token-manager/token-manager.service';
import { LogoutService } from '@cutting/main/shared/services/logout.service';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import * as Sentry from '@sentry/angular-ivy';
import { AngularSplitModule } from 'angular-split';
import { CustomDateAdapter, getSaver, IconsModule, NgxLocalizedNumbers, SAVER } from 'cloud-shared-lib';
import '../app/config/quill.config';
import { AppRoutingModule } from './app-routing.module';
import { ClientModule } from './main/client/client.module';
import { OrderModule } from './main/order/order.module';

import '@angular/common/locales/global/ru';
import { Router } from '@angular/router';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    AppRoutingModule,
    OrderModule,
    ClientModule,

    AngularSplitModule.forRoot(),

    // Material
    MatButtonModule,
    MatIconModule,

    // Fuse modules
    FuseModule.forRoot(fuseConfig),
    FuseProgressBarModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,

    // App modules
    LayoutModule,
    NgxLocalizedNumbers.forRoot(),
    IconsModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    TokenManagerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    LogoutService,
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2000, verticalPosition: 'top' } },
    [{ provide: SAVER, useFactory: getSaver }],
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
